import { useState, useEffect } from "react";
import { Link, useLocation } from "wouter";
import { Menu, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { LogoMark } from "@/components/public/logo-mark";
import { Container } from "@/components/public/institutional-ui";

const navItems = [
  { label: "Home", href: "/" },
  { label: "What We Do", href: "/what-we-do" },
  { label: "Velocity Fund", href: "/velocity" },
  { label: "Transactions", href: "/transactions" },
  { label: "About", href: "/about" },
  { label: "Insights", href: "/insights" },
  { label: "Contact", href: "/contact" },
];

export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [location] = useLocation();

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (href: string) => {
    if (href === "/") return location === "/";
    return location === href || location.startsWith(`${href}/`);
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 border-b border-border/80 bg-background/95 backdrop-blur-sm"
      style={{ height: "4.5rem" }}
    >
      <Container className="h-full flex items-center gap-4 lg:gap-6">
        <Link href="/" className="shrink-0 hover:opacity-80 transition-opacity">
          <LogoMark size="md" />
        </Link>

        <nav className="hidden lg:flex items-center justify-center gap-6 xl:gap-8 flex-1">
          {navItems.map((item) => (
            <Link key={item.href} href={item.href}>
              <span
                className={cn(
                  "text-[13px] tracking-wide transition-opacity cursor-pointer whitespace-nowrap",
                  isActive(item.href)
                    ? "text-foreground font-medium"
                    : "text-muted-foreground hover:text-foreground"
                )}
              >
                {item.label}
              </span>
            </Link>
          ))}
        </nav>

        <button
          type="button"
          className="lg:hidden p-2 -mr-2 ml-auto"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
        >
          {isMobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </Container>

      {isMobileMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 w-full border-t border-border bg-background shadow-lg max-h-[85vh] overflow-y-auto">
          <nav className="gc-container py-4 flex flex-col">
            {navItems.map((item) => (
              <Link key={item.href} href={item.href}>
                <span
                  className={cn(
                    "block py-3 text-sm border-b border-border/50 cursor-pointer",
                    isActive(item.href) ? "text-foreground font-medium" : "text-muted-foreground"
                  )}
                >
                  {item.label}
                </span>
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
